import moment from 'moment'
import Model from '@/models/Model'

export default class AccLedger extends Model {
    resource() {
        return 'acc_ledger'
    }

    get generatorUserName() {
        return this.g_user && this.g_user.hr_employee
            ? this.g_user.hr_employee.name_case
            : null
    }

    get initDate() {
        return this.init_date
            ? moment(this.init_date).format('DD-MM-YYYY')
            : null
    }

    get endDate() {
        return this.end_date ? moment(this.end_date).format('DD-MM-YYYY') : null
    }

    static includes = ['g_user.hr_employee']
}
